// src/pages/formalities/FormalitiesTemplatesPage.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import FormalitiesCategories from "components/formalities/FormalitiesCategories";
import FormalitiesTemplates from "components/formalities/FormalitiesTemplates";
import FormalitiesTemplatesSearch from "components/formalities/helpers/FormalitiesTemplatesSearch";
import API from "api";
import Swal from "sweetalert2";
import { debug } from "utils"
import CMSBlock from "components/cms/CMSBLock";
import './page-formalities-templates.css';
export default function FormalitiesTemplatesPage() {
  const { catId } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [loadingCat, setLoadingCat] = useState(false);
  useEffect(() => {
    if (!catId) {
      setCategory(null);
      return;
    }
    loadCategory(catId);
  }, [catId]);

  const loadCategory = async (slug) => {

    try {
      setLoadingCat(true);
      API.handleError = false;
      const res = await API.get(`/formalities/categories/${slug}`);
      setCategory(res.data);
    } catch (e) {
      Swal.fire({
        text:
          e.response?.data?.error?.message ||
          "Le chargement de la catégorie a échoué.",
        icon: null
      }).finally(() => {
        navigate("/formalities/templates");
      });

    } finally {
      setLoadingCat(false);
    }
  };

  return (
    <div id="page-formalities-templates" className="page">
      <div className="">
        {!catId && (
          <div>
            <CMSBlock
              blockId="page-formalities-categories-content-header"
              titleTag="h1"
              contentsClassName="container"
            />
            <div>
              <div className="bg-primary-20 py-5 text-white">
                <div className="section-title">
                  <h2 className="mb-2">
                    <span className="badge badge-sm bg-primary rounded-pill fw-normal mb-2 px-3 fs-7 text-uppercase">
                      Rechercher une formalité
                    </span>
                  </h2>
                </div>


                <div className=" px-2 px-md-0">
                  <FormalitiesTemplatesSearch />
                </div>


              </div>
              <div className="container py-5">
                <FormalitiesCategories
                  onSelectCategory={(cat) => {
                    navigate(`/formalities/templates/${cat.fcSlug}`);
                  }}

                />
              </div>
            </div>
            <div className="">
              <CMSBlock
                blockId="page-formalities-categories-footer"
                titleTag="h2"
                contentsClassName="container"
              />
            </div>
          </div>
        )}
        {category && (
          <div className="">
            <div className="content-header">
              <div className="background">
                {category.fcCover && (
                  <img src={`https://formalites.fortium.fr/msmedias/.formalities/assets/${category.fcCover}`} />
                )}
                <div className="overlay"></div>
              </div>
              <div className="wordings position-relative container text-center" style={{ maxWidth: '600px' }}>
                <div className="cms-block-title">
                  <h1 className="">
                    <span className="">{category.fcName}</span>
                  </h1>
                </div>
                {category.fcSummary && (
                  <div className="cms-block-subtitle">{category.fcSummary}</div>
                )}
              </div>
            </div>
            <div className="container my-5">
              <div className="">
                <FormalitiesTemplates
                  catId={catId}
                  onSelectCategory={(cat) => {

                    navigate(`/formalities/templates/${cat.fcSlug}`);
                  }}
                  onBackToCategories={() => {
                    navigate("/formalities/templates");
                  }}
                  onSelectTemplate={(tpl) => {
                    navigate(`/formalities/request/create/${tpl.ftId}`);
                  }}
                  onBack={() => {
                    navigate(`/formalities/templates`);
                  }}
                />
              </div>
            </div>
            <CMSBlock
              blockId={`page-formalities-category-${category.fcSlug}`}
              className=""
              contentsClassName="container"
            />
          </div>
        )}
      </div>
    </div>
  );
}
